module.exports = __webpack_public_path__ + "img/icon_4.7811faef.svg";